/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ClosureResponseDto,
  CreateClosureCommandControllerCreate201,
  CreateClosureDto,
  UpdateClosureCommandControllerUpdate200,
  UpdateClosureDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Record a non-operating day or range for a nursery
 */
export const createClosureCommandControllerCreate = (
  nurseryId: string,
  createClosureDto: CreateClosureDto,
  signal?: AbortSignal,
) => {
  return axiosClient<CreateClosureCommandControllerCreate201>({
    url: `/v1/nurseries/${nurseryId}/closures`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createClosureDto,
    signal,
  });
};

export const getCreateClosureCommandControllerCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClosureCommandControllerCreate>>,
    TError,
    { nurseryId: string; data: CreateClosureDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createClosureCommandControllerCreate>>,
  TError,
  { nurseryId: string; data: CreateClosureDto },
  TContext
> => {
  const mutationKey = ["createClosureCommandControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createClosureCommandControllerCreate>>,
    { nurseryId: string; data: CreateClosureDto }
  > = (props) => {
    const { nurseryId, data } = props ?? {};

    return createClosureCommandControllerCreate(nurseryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateClosureCommandControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createClosureCommandControllerCreate>>
>;
export type CreateClosureCommandControllerCreateMutationBody = CreateClosureDto;
export type CreateClosureCommandControllerCreateMutationError = void;

/**
 * @summary Record a non-operating day or range for a nursery
 */
export const useCreateClosureCommandControllerCreate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createClosureCommandControllerCreate>>,
      TError,
      { nurseryId: string; data: CreateClosureDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createClosureCommandControllerCreate>>,
  TError,
  { nurseryId: string; data: CreateClosureDto },
  TContext
> => {
  return useMutation(
    getCreateClosureCommandControllerCreateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary List all non-operating days for a nursery
 */
export const listClosuresQueryControllerList = (
  nurseryId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<ClosureResponseDto[]>({
    url: `/v1/nurseries/${nurseryId}/closures`,
    method: "GET",
    signal,
  });
};

export const getListClosuresQueryControllerListQueryKey = (
  nurseryId: string,
) => {
  return [`/v1/nurseries/${nurseryId}/closures`] as const;
};

export const getListClosuresQueryControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof listClosuresQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listClosuresQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListClosuresQueryControllerListQueryKey(nurseryId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listClosuresQueryControllerList>>
  > = ({ signal }) => listClosuresQueryControllerList(nurseryId, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listClosuresQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListClosuresQueryControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof listClosuresQueryControllerList>>
>;
export type ListClosuresQueryControllerListQueryError = void;

export function useListClosuresQueryControllerList<
  TData = Awaited<ReturnType<typeof listClosuresQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listClosuresQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClosuresQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listClosuresQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListClosuresQueryControllerList<
  TData = Awaited<ReturnType<typeof listClosuresQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listClosuresQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClosuresQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listClosuresQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListClosuresQueryControllerList<
  TData = Awaited<ReturnType<typeof listClosuresQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listClosuresQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all non-operating days for a nursery
 */

export function useListClosuresQueryControllerList<
  TData = Awaited<ReturnType<typeof listClosuresQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listClosuresQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListClosuresQueryControllerListQueryOptions(
    nurseryId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a nursery closure
 */
export const updateClosureCommandControllerUpdate = (
  nurseryId: string,
  closureId: string,
  updateClosureDto: UpdateClosureDto,
  signal?: AbortSignal,
) => {
  return axiosClient<UpdateClosureCommandControllerUpdate200>({
    url: `/v1/nurseries/${nurseryId}/closures/${closureId}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateClosureDto,
    signal,
  });
};

export const getUpdateClosureCommandControllerUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClosureCommandControllerUpdate>>,
    TError,
    { nurseryId: string; closureId: string; data: UpdateClosureDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateClosureCommandControllerUpdate>>,
  TError,
  { nurseryId: string; closureId: string; data: UpdateClosureDto },
  TContext
> => {
  const mutationKey = ["updateClosureCommandControllerUpdate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateClosureCommandControllerUpdate>>,
    { nurseryId: string; closureId: string; data: UpdateClosureDto }
  > = (props) => {
    const { nurseryId, closureId, data } = props ?? {};

    return updateClosureCommandControllerUpdate(nurseryId, closureId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateClosureCommandControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateClosureCommandControllerUpdate>>
>;
export type UpdateClosureCommandControllerUpdateMutationBody = UpdateClosureDto;
export type UpdateClosureCommandControllerUpdateMutationError = void;

/**
 * @summary Update a nursery closure
 */
export const useUpdateClosureCommandControllerUpdate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateClosureCommandControllerUpdate>>,
      TError,
      { nurseryId: string; closureId: string; data: UpdateClosureDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateClosureCommandControllerUpdate>>,
  TError,
  { nurseryId: string; closureId: string; data: UpdateClosureDto },
  TContext
> => {
  return useMutation(
    getUpdateClosureCommandControllerUpdateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Remove a nursery closure
 */
export const removeClosureCommandControllerRemove = (
  nurseryId: string,
  closureId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${nurseryId}/closures/${closureId}`,
    method: "DELETE",
    signal,
  });
};

export const getRemoveClosureCommandControllerRemoveMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeClosureCommandControllerRemove>>,
    TError,
    { nurseryId: string; closureId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeClosureCommandControllerRemove>>,
  TError,
  { nurseryId: string; closureId: string },
  TContext
> => {
  const mutationKey = ["removeClosureCommandControllerRemove"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeClosureCommandControllerRemove>>,
    { nurseryId: string; closureId: string }
  > = (props) => {
    const { nurseryId, closureId } = props ?? {};

    return removeClosureCommandControllerRemove(nurseryId, closureId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveClosureCommandControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeClosureCommandControllerRemove>>
>;

export type RemoveClosureCommandControllerRemoveMutationError = void;

/**
 * @summary Remove a nursery closure
 */
export const useRemoveClosureCommandControllerRemove = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeClosureCommandControllerRemove>>,
      TError,
      { nurseryId: string; closureId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeClosureCommandControllerRemove>>,
  TError,
  { nurseryId: string; closureId: string },
  TContext
> => {
  return useMutation(
    getRemoveClosureCommandControllerRemoveMutationOptions(options),
    queryClient,
  );
};
